import { ChangeDetectionStrategy, Component } from '@angular/core';

const { version } = require('package.json');

@Component({
    selector: 'sl-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FooterComponent {
    date = new Date();
    appVersion = version;
}
